package com.exura.features.plandefinition.presentation

import androidx.compose.runtime.Composable
import com.exura.components.icons.InlineIcon
import com.exura.components.icons.UntiledIcon
import com.exura.components.pageTypography.ExuraCommentaryTextVariant
import com.exura.components.pageTypography.UnderwrittenText
import com.varabyte.kobweb.silk.components.text.SpanText

@Composable
internal fun PlanStatisticElement(
    underwriteText: String,
    iconSrc: String,
    content: @Composable () -> Unit,
) {
    UnderwrittenText(
        underwriteVariant = ExuraCommentaryTextVariant,
        underwrite = { SpanText(underwriteText) },
    ) {
        InlineIcon(
            icon = { UntiledIcon(iconSrc) }) { content() }
    }
}
